import { Text } from '@medly-components/core';
import { STATION_DESCRIPTION_WIDTH } from 'constants/map';
import styled, { css } from 'styled-components';
import { ReactComponent as EllipsisIcon } from '../../../../../../../../../../assets/svg/ellipsis.svg';
import ActiveLocationIcon from '../ActiveLocationIcon';
import { SearchStatus } from 'context/MapSearchContext/types';

const DescriptionLeftPadding = '4.4rem';
const STATION_DESCRIPTION_WIDTH_WITH_PADDING = STATION_DESCRIPTION_WIDTH + 30;
export const StationCurrentLocationIcon = styled(ActiveLocationIcon)`
    position: absolute;
    top: -2rem;
    right: 0.6rem;
    z-index: -1;
`;

export const Ellipsis = styled(EllipsisIcon)`
    display: inline-block;
    vertical-align: middle;
    padding-left: 0.5rem;
    width: 30px;
    height: 14px;
`;

export const scalingTextStyles = css<{ scale: number }>`
    font-size: ${({ scale }) => `min(${20 / scale}px, 20px)`};
    line-height: initial;

    ${Ellipsis} {
        width: ${({ scale }) => `min(${30 / scale}px, 40px)`};
        height: ${({ scale }) => `min(${14 / scale}px, 18px)`};
    }

    ${StationCurrentLocationIcon} {
        top: ${({ scale }) => `min(-${24 / scale}px, -48px)`};
    }
`;

export const DescriptionText = styled(Text)`
    font-weight: 400;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    border-radius: 5rem;
    box-sizing: border-box;
    margin-left: 3.4rem;
`;

export const DescriptionContainer = styled.div<{ scale: number }>`
    max-width: ${STATION_DESCRIPTION_WIDTH}px;
    width: max-content;
    position: absolute;
    transform: translateY(-50%);
    z-index: -1;
    top: 50%;
    display: flex;
    align-items: center;
    cursor: pointer;

    ${DescriptionText} {
        ${({ scale }) => scale && scalingTextStyles};
    }
`;

const activeStyles = css`
    ${DescriptionContainer} {
        max-width: ${STATION_DESCRIPTION_WIDTH_WITH_PADDING}px;
    }
    ${DescriptionText} {
        padding: 0.7rem 1.4rem 0.7rem ${DescriptionLeftPadding};
        border: 0.2rem solid ${({ theme }) => theme.colors.coral[300]};
        color: #0a0a0a;
        margin-left: 0;
    }
`;

const withBackgroundStyles = css<{ backgroundColor: string }>`
    ${DescriptionText} {
        background-color: ${({ backgroundColor }) => backgroundColor};
    }
`;

export const hoverStyles = css`
    color: ${({ theme }) => theme.colors.coral[500]};
    line-height: 2;

    ${DescriptionText} {
        padding: 0.8rem 0.8rem 0.8rem ${DescriptionLeftPadding};
        margin-left: 0;
        box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5);
    }
`;

const searchActiveDescriptionTextStyles = css`
    color: white;
    border: 0.1rem solid ${({ theme }) => theme.colors.royalBlue[200]};
`;

const searchDescriptionTextStyles = css<{ className: string }>`
    border-radius: 0.4rem;
    padding: 0.1rem 0.3rem;
    color: ${({ theme }) => theme.colors.darkBlue};
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[200]};
    ${({ className }) => className === SearchStatus.SEARCH_ACTIVE && searchActiveDescriptionTextStyles};
`;

const searchDescriptionStyles = css<{ className: string }>`
    ${DescriptionText} {
        margin-left: 4.3rem;
        padding: 0.8rem 0.8rem 0.8rem ${DescriptionLeftPadding};
        ${searchDescriptionTextStyles};
    }
`;

const searchDescriptionHoverStyles = css<{ searchBackgroundColor: string | null; className: string }>`
    ${DescriptionText} span {
        ${searchDescriptionTextStyles};
        background-color: ${({ searchBackgroundColor }) => searchBackgroundColor};
    }
`;

export const DescriptionWrapper = styled.div<{
    isActiveStation: boolean;
    isExpand: boolean;
    backgroundColor: string;
    className: string;
    searchBackgroundColor: string | null;
}>`
    position: absolute;
    left: calc(100% - 4rem);
    ${({ isExpand }) => isExpand && hoverStyles};
    ${({ backgroundColor }) => backgroundColor && withBackgroundStyles};
    ${({ isActiveStation }) => isActiveStation && activeStyles};
    ${({ className, isExpand }) => (isExpand && className ? searchDescriptionHoverStyles : className && searchDescriptionStyles)};
`;
